<template>
  <div
    class="z-msg__item"
    :class="{'z-msg__item--read': isRead}"
    @click="itemClick(itemData)"
  >
    <!-- 左侧图标 -->
    <div class="z-msg__avatar">
      <img
        src="https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png"
        alt=""
      >
    </div>

    <!-- 右侧内容 -->
    <div class="z-msg__content">
      <div
        class="z-msg__shorthand"
      >
        {{itemData.shorthand}}
      </div>

      <div class="z-msg__time">
        {{itemData.time}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'z-msg-item',
  props: {
    itemData: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      isRead: false,
      iconMap: {
        dingtalk: 'https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png',
        add: 'https://gw.alipayobjects.com/zos/rmsportal/kISTdvpyTAhtGxpovNWd.png',
        star: 'https://gw.alipayobjects.com/zos/rmsportal/GvqBnKhFgObvnSGkDsje.png',
        email: 'https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png',
      }
    }
  },
  methods: {
    itemClick (item) {
      this.isRead = true

      this.$emit('click', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.z-msg__item {
  box-sizing: border-box;
  display: flex;

  padding: 10px 16px;
  height: 78px;

  border-bottom: 1px solid #e8e8e8;

  font-size: 13px;
  color: rgab(0, 0, 0, 0.65);

  cursor: pointer;

  &:hover {
    background-color: #ecf5ff;
  }
}
.z-msg__item--read {
  opacity: 0.4;
}
.z-msg__avatar {
  box-sizing: border-box;
  padding-right: 10px;
  width: 48px;
  line-height: 57px;
  text-align: center;

  img {
    vertical-align: middle;
    width: 32px;
  }
}

.z-msg__content {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}
.z-msg__shorthand {
  width: 100%;
  line-height: 18px;
}
.z-msg__time {
  line-height: 18px;
}
</style>
